export default __webpack_public_path__ + "static/media/team1.124d08f4.jpg";